module.exports = __webpack_public_path__ + "static/media/image_06.d90f489e.jpg";